<footer class="footer">
  <!-- Left section with copyright -->
  <div class="footer-left">
    <span class="footer-brand-text">
      {{ 'footer.copyright' | translate: { year: getCurrentYear() } }}
    </span>
  </div>

  <!-- Center section with logo -->
  <div class="footer-center">
    <img src="/ewents-logo-navy.svg" alt="Ewents Logo" class="footer-logo" />
  </div>

  <!-- Right section with designed by -->
  <div class="footer-right">
    <span class="footer-designed-text">{{ 'footer.designedBy' | translate }}</span>
  </div>
</footer>
